import React, { useEffect, useState } from "react";
import moment from "moment";
import auth from "../Service/AuthFetchService";
import {
  Button,
  Cascader,
  Divider,
  Select,
  Tabs,
  Table,
  Row,
  Col,
  Modal,
  Input,
  DatePicker,
  Spin,
  message,
  Popover,
  Popconfirm,
} from "antd";
import { PlusOutlined, SearchOutlined, SaveOutlined } from "@ant-design/icons";
import ReactEcharts from "echarts-for-react";
import ConditionsEditor from "./ConditionsEditor";
import "./EventAnalysis.css";
import { isEmpty, isNotEmpty, samplingConstants } from "../Service/Utils";
import UIFetchService from "../Service/UIFetchService";

class RealtimeAnalysis extends React.Component {
  constructor() {
    super();
    const colors = [
      "#63b2ee",
      "#76da91",
      "#f8cb7f",
      "#f89588",
      "#7cd6cf",
      "#9192ab",
      "#7898e1",
      "#efa666",
      "#eddd86",
      "#9987ce",
      "#63b2ee",
      "#76da91",
    ];
    this.state = {
      showingSaveModal: false,
      canSave: false,
      eventSelectors: [
        {
          id: 1,
          projectName: null,
          eventClassificationOptions: [
            { label: "事件分组", value: "事件分组", children: [] },
            { label: "事件类型", value: "事件类型", children: [] },
          ],
          eventOptions: [],
          propertiesSelector: null,
          eventProperties: [],
        },
      ],
      projectOptions: samplingConstants.projects.map((p) => {
        return { title: p.title, value: p.value };
      }),
      chartType: "history",
      historyLoading: false,
      todayLoading: false,
      chartOption: {
        color: colors,
        legend: {
          orient: "vertical",
          height: 55,
          data: [],
          icon: "circle",
        },
        xAxis: {
          type: "category",
          data: [],
          axisLine: {
            show: true,
            lineStyle: {
              color: "#8c8c8c",
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: "#8c8c8c",
            },
          },
        },
        yAxis: {
          type: "value",
          axisTick: {
            //y轴刻度线
            show: false,
          },
          axisLine: {
            //y轴
            show: false,
          },
          axisLabel: {
            //y轴文字的配置
            textStyle: {
              color: "#8c8c8c",
              margin: 15,
            },
          },
          splitLine: {
            lineStyle: {
              color: "#F5F7F8",
            },
          },
        },
        grid: {
          left: 80,
        },
        tooltip: {
          trigger: "axis",
        },
        series: [
          {
            data: [],
            type: "line",
            smooth: 0.5,
          },
        ],
      },
      chartOptionToday: {
        color: colors,
        legend: {
          orient: "vertical",
          height: 55,
          data: [],
          icon: "circle",
        },
        xAxis: {
          type: "category",
          data: [],
          axisLine: {
            show: true,
            lineStyle: {
              color: "#8c8c8c",
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: "#8c8c8c",
            },
          },
        },
        yAxis: {
          type: "value",
          axisTick: {
            //y轴刻度线
            show: false,
          },
          axisLine: {
            //y轴
            show: false,
          },
          axisLabel: {
            //y轴文字的配置
            textStyle: {
              color: "#8c8c8c",
              margin: 15,
            },
          },
          splitLine: {
            lineStyle: {
              color: "#F5F7F8",
            },
          },
        },
        grid: {
          left: 80,
        },
        tooltip: {
          trigger: "axis",
        },
        series: [
          {
            data: [],
            type: "line",
          },
        ],
      },
      d7histValues: {},
      rangeDate: [undefined, undefined],
      lastRealtimeHistSelectorJson: null,
      lastRealtimeTodaySelectorJson: null,
    };
  }

  async componentDidMount() {
    //const today = moment()
    const yesterday = moment().subtract(1, "days");
    const d30 = moment().subtract(30, "days");

    if (this.props.defId != null) {
      const result = await UIFetchService.get(
        `/api/v1/sampling/event/getSelectorByDefId?defId=${this.props.defId}`
      );
      if (result == null) {
        return;
      }
      let { eventSelectors } = this.state;
      eventSelectors = [];
      const selector = {
        id: result.id,
        projectName: result.projectName,
        eventName: result.eventName,
        statisticObject: result.statisticObject,
        classificationType: result.classificationType,
        classificationValue: result.classificationValue,
        eventClassificationOptions: [
          {
            label: "事件分组",
            value: "事件分组",
            children: result.eventGroupOptions.map((eg) => {
              return { label: eg, value: eg, children: [] };
            }),
          },
          {
            label: "事件类型",
            value: "事件类型",
            children: result.eventTypeOptions.map((et) => {
              return { label: et, value: et, children: [] };
            }),
          },
        ],
        eventOptions: result.eventOptions,
        eventProperties: result.eventProperties,
      };
      eventSelectors.push(selector);

      this.setState(
        { eventSelectors, rangeDate: [d30, yesterday] },
        async () => await this._doQuery()
      );
    } else {
      if (this.props.template != null) {
        const templateCreatedAt7d = moment(
          this.props.template.createdAt
        ).subtract(7, "days");
        const startDate = templateCreatedAt7d.isAfter(d30)
          ? templateCreatedAt7d
          : d30;
        this.setState(
          {
            eventSelectors: JSON.parse(this.props.template.templateSelector),
            rangeDate: [startDate, yesterday],
          },
          () => this._doQuery()
        );
      } else {
        const selectorJson = localStorage.getItem(
          "event_realtime_ayalysis.selectors"
        );
        if (isNotEmpty(selectorJson)) {
          const selectors = JSON.parse(selectorJson);
          if (
            selectors.length > 0 &&
            selectors[0].eventOptions &&
            selectors[0].eventOptions[0] &&
            selectors[0].eventOptions[0].eventName
          ) {
            this.setState({ eventSelectors: JSON.parse(selectorJson) });
          }
        }

        this.setState({ rangeDate: [d30, yesterday] });
      }
    }
  }

  async _copyEventSelector(selector) {
    const { eventSelectors } = this.state;
    const newSelector = JSON.parse(JSON.stringify(selector));
    newSelector.id = Math.max(...eventSelectors.map((s) => s.id)) + 1;
    eventSelectors.push(newSelector);
    this.setState({ eventSelectors });
  }

  async _projectSelected(selector, value) {
    const { eventSelectors } = this.state;
    const eventTypes = await UIFetchService.get(
      `/api/v1/sampling/definitions/project/${value}/eventTypes`
    );
    const eventGroups = await UIFetchService.get(
      `/api/v1/sampling/definitions/project/${value}/eventGroups`
    );
    selector.projectName = value;
    // 事件分组
    selector.eventClassificationOptions[0].children = eventGroups.map((eg) => {
      return { label: eg, value: eg, children: [] };
    });
    // 事件类型
    selector.eventClassificationOptions[1].children = eventTypes.map((et) => {
      return { label: et, value: et, children: [] };
    });
    selector.classificationType = null;
    selector.classificationValue = null;
    selector.eventName = null;
    selector.eventOptions = [];
    selector.propertiesSelector = null;
    selector.eventProperties = [];

    this.setState({ eventSelectors });
  }

  async _eventClassificationSelected(selector, value) {
    const { eventSelectors } = this.state;
    selector.classificationType = value[0];
    selector.classificationValue = value[1];

    const eventNames = await UIFetchService.get(
      `/api/v1/sampling/definitions/project/${selector.projectName}/eventNames?eventClassificationType=${selector.classificationType}&eventClassificationValue=${selector.classificationValue}`
    );

    selector.eventName = null;
    selector.eventOptions = eventNames;
    selector.propertiesSelector = null;
    selector.eventProperties = [];
    this.setState({ eventSelectors });
  }

  async eventSelected(s, value) {
    s.eventName = value;

    const props = await this.getEventProperties(s);
    this.setState(async ({ eventSelectors }) => {
      s.eventProperties = props;
      s.propertiesSelector = null;
      return { eventSelectors };
    });
  }

  async _doQuery() {
    window.CyaLogger?.sendClick(null, "shijianfenxi_chaxun_click", {
      user_name: this.props.user.account,
    });

    const { chartType, eventSelectors, chartOption, chartOptionToday } =
      this.state;
    const requestBody = {
      type: chartType,
      conditions: eventSelectors.map((s) => {
        return {
          id: s.id,
          projectName: s.projectName,
          eventGroup:
            s.classificationType === "事件分组" ? s.classificationValue : null,
          eventName: s.eventName,
          statisticObject: s.statisticObject,
          propertiesSelector: s.propertiesSelector,
        };
      }),
    };

    const today = moment();
    if (this.props.template != null) {
      requestBody.templateId = this.props.template.id;
    }

    let option = null;
    if (chartType === "history") {
      requestBody.startDate = this.state.rangeDate[0].format("YYYY-MM-DD");
      requestBody.endDate = this.state.rangeDate[1].format("YYYY-MM-DD");
      option = chartOption;
      this.setState({ historyLoading: true });
    } else {
      requestBody.startDate = today.format("YYYY-MM-DD");
      requestBody.endDate = today.format("YYYY-MM-DD");
      option = chartOptionToday;
      this.setState({ todayLoading: true });
    }

    const result = await UIFetchService.get(
      "/api/v1/sampling/event/query?selectors=" +
        encodeURI(JSON.stringify(requestBody))
    );
    if (result == null || Object.keys(result).length === 0) {
      this.setState({ historyLoading: false, todayLoading: false });
      return;
    }

    let d7histValues = {};
    if (this.props.template == null) {
      for (let k of Object.keys(result)) {
        d7histValues[k] = result[k].slice(-7);
      }
    }

    const keys = Object.keys(result);
    option.legend.data = keys;
    option.xAxis.data = Object.values(result)[0].map((a) =>
      a.time.length === 10 ? a.time.substring(5) : a.time
    );
    option.series = Object.values(result).map((a, i) => {
      return {
        name: keys[i],
        showSymbol: false,
        data: a.map((e) => (e.value != null ? e.value : 0)),
        type: "line",
        smooth: 0.3,
      };
    });

    const selectorJson = JSON.stringify(eventSelectors);
    if (chartType === "history") {
      let histJson = this.state.lastRealtimeHistSelectorJson;
      let canSave = false;
      if (this.props.template == null) {
        if (histJson != selectorJson) {
          canSave = true;
        }
        histJson = selectorJson;
      }
      this.setState({
        chartOption: option,
        historyLoading: false,
        d7histValues: d7histValues,
        lastRealtimeHistSelectorJson: histJson,
        canSave: canSave,
      });
    } else {
      let todayJson = this.state.lastRealtimeTodaySelectorJson;
      if (this.props.template == null) {
        todayJson = selectorJson;
      }
      this.setState({
        chartOptionToday: option,
        todayLoading: false,
        d7histValues: d7histValues,
        lastRealtimeTodaySelectorJson: todayJson,
      });
    }

    if (this.props.template == null) {
      localStorage.setItem("event_realtime_ayalysis.selectors", selectorJson);
    }
  }

  async _saveTemplate() {
    this.setState({ showingSaveModal: true });
  }

  async _saveTemplateCompleted() {
    this.setState({ showingSaveModal: false, canSave: false });
  }

  async chartTypeChange(t) {
    this.setState({ chartType: t }, () => {
      if (this.props.template != null) {
        if (
          (t === "history" && this.state.chartOption.xAxis.data.length === 0) ||
          (t === "today" && this.state.chartOptionToday.xAxis.data.length === 0)
        ) {
          this._doQuery();
        }
      } else {
        const json = JSON.stringify(this.state.eventSelectors);
        if (
          (t === "history" &&
            this.state.lastRealtimeHistSelectorJson !== json) ||
          (t === "today" && this.state.lastRealtimeTodaySelectorJson !== json)
        ) {
          this._doQuery();
        }
      }
    });
  }

  async historyRangeDateChange(date) {
    this.setState({ rangeDate: date }, () => this._doQuery());
  }

  async showPropertiesSelector(selector) {
    if (selector.eventProperties == null) {
      const props = await this.getEventProperties(selector);
      if (props != null) {
        selector.eventProperties = props;
      }
    }

    this.setState(({ eventSelectors }) => {
      if (selector.propertiesSelector == null) {
        selector.propertiesSelector = {
          root: true,
          logic: "OR",
          type: "LOGIC",
          nodes: [
            {
              type: "EVE_PROP",
            },
          ],
        };
      }
      return { eventSelectors };
    });
  }

  async getEventProperties(s) {
    let eventGroup = null;
    if (s.classificationType === "事件分组") {
      eventGroup = s.classificationValue;
    }

    return await UIFetchService.get(
      `/api/v1/sampling/event/eventProperties?projectName=${
        s.projectName
      }&eventName=${s.eventName}&eventGroup=${
        eventGroup == null ? "" : eventGroup
      }`
    );
  }

  syncPropertiesSelector(selector, conditions) {
    this.setState(({ eventSelectors }) => {
      selector.propertiesSelector = conditions;
      return { eventSelectors };
    });
  }

  _isEmptyData() {
    const chartOptions = [this.state.chartOption, this.state.chartOptionToday];
    for (let option of chartOptions) {
      if (
        option.series != null &&
        option.series.length > 0 &&
        option.series[0].data != null &&
        option.series[0].data.length > 0
      ) {
        return false;
      }
    }

    return true;
  }

  render() {
    const historyDisabledDate = (current) => {
      if (this.props.template == null) {
        return false;
      }

      const templateCreatedAt7d = moment(
        this.props.template.createdAt
      ).subtract(7, "days");
      return current < templateCreatedAt7d || current > moment();
    };

    const emptyData = this._isEmptyData();

    return (
      <>
        <div className="event-select-area">
          <Row
            style={{
              textAlign: "left",
              padding: "0 10px 0 10px",
              margin: "10px 0 10px 0",
            }}
          >
            <Col flex="50px">
              <h1>事件</h1>
            </Col>
            <Col>
              {this.props.template != null ? null : (
                <Button
                  type="primary"
                  size="small"
                  onClick={() => {
                    this.setState(({ eventSelectors }) => {
                      let id = 1;
                      if (eventSelectors.length > 0) {
                        id = Math.max(...eventSelectors.map((s) => s.id)) + 1;
                      }
                      eventSelectors.push({
                        id: id,
                        projectName: null,
                        eventClassificationOptions: [
                          {
                            label: "事件分组",
                            value: "事件分组",
                            children: [],
                          },
                          {
                            label: "事件类型",
                            value: "事件类型",
                            children: [],
                          },
                        ],
                      });

                      return eventSelectors;
                    });
                  }}
                >
                  {" "}
                  <PlusOutlined /> 事件
                </Button>
              )}
            </Col>
            <Col flex="auto"></Col>
            <Col flex="100px">
              {this.props.template != null ? null : (
                <Popover content="请先查询历史数据成功后再保存为模板">
                  <Button
                    style={{ width: 135 }}
                    icon={<SaveOutlined />}
                    size="small"
                    type="primary"
                    disabled={!this.state.canSave}
                    onClick={this._saveTemplate.bind(this)}
                  >
                    保存为模板&nbsp;
                  </Button>
                </Popover>
              )}
            </Col>
            <Col flex="100px"></Col>
          </Row>
          <Divider
            style={{
              margin: "10px 0 20px 0",
              borderTop: "1px dashed #ccc",
            }}
          />
          {this.state.eventSelectors.map((s, index) => (
            <div className="event-selector" key={index}>
              <Row style={{ marginTop: 6 }} align="middle">
                <Col flex="40px">
                  <span style={{ color: "#1890ff" }}>
                    {" "}
                    {String.fromCharCode("A".charCodeAt(0) + s.id - 1)}{" "}
                  </span>
                </Col>
                <Col style={{ paddingRight: 6 }}>
                  <Select
                    className="tmplSelector"
                    placeholder="项目组"
                    showSearch
                    value={s.projectName}
                    style={{ width: 150 }}
                    onChange={async (value) => this._projectSelected(s, value)}
                    disabled={this.props.template != null}
                    filterOption={(input, option) =>
                      option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {this.state.projectOptions.map((project) => (
                      <Select.Option key={project.title} value={project.value}>
                        {" "}
                        {project.title + " (" + project.value + ")"}{" "}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>
                <Col style={{ paddingLeft: 6, paddingRight: 6 }}>
                  <Cascader
                    className="tmplCascader"
                    options={s.eventClassificationOptions}
                    value={
                      s.classificationType != null
                        ? [s.classificationType, s.classificationValue]
                        : []
                    }
                    onChange={async (value) =>
                      this._eventClassificationSelected(s, value)
                    }
                    placeholder="事件分类"
                    style={{ width: 180 }}
                    disabled={this.props.template != null}
                  />
                </Col>
                <Col style={{ paddingLeft: 6, paddingRight: 6 }}>
                  <Select
                    className="tmplSelector"
                    disabled={this.props.template != null}
                    showSearch
                    filterOption={(input, option) => {
                      return (
                        option.key.toLowerCase().indexOf(input.toLowerCase()) >=
                          0 ||
                        option.value
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                    placeholder="任意事件"
                    value={s.eventName}
                    style={{ width: 300 }}
                    onChange={async (value) => this.eventSelected(s, value)}
                  >
                    {s.eventOptions != null
                      ? s.eventOptions.map((e) => (
                          <Select.Option
                            key={e.eventNameChs + e.eventName}
                            value={e.eventNameChs}
                          >
                            {" "}
                            {e.eventNameChs + " " + e.eventName}{" "}
                          </Select.Option>
                        ))
                      : null}
                  </Select>
                </Col>
                <Col style={{ paddingLeft: 6, paddingRight: 6 }}>
                  <span>&nbsp;的&nbsp;</span>
                </Col>
                <Col style={{ paddingLeft: 6, paddingRight: 6 }}>
                  <Select
                    className="tmplSelector"
                    disabled={this.props.template != null}
                    placeholder="统计值"
                    value={s.statisticObject}
                    style={{ width: 150 }}
                    onChange={async (value) => {
                      this.setState(({ eventSelectors }) => {
                        s.statisticObject = value;
                        return { eventSelectors };
                      });
                    }}
                  >
                    <Select.Option value="times"> 总次数 </Select.Option>
                    <Select.Option value="users"> 总用户数 </Select.Option>
                    <Select.Option value="devices">
                      {" "}
                      总设备数(device_id){" "}
                    </Select.Option>
                  </Select>
                </Col>
                {this.props.template != null ? null : (
                  <Col flex="150px">
                    <Button
                      size="small"
                      type="link"
                      onClick={() => this.showPropertiesSelector(s)}
                    >
                      筛选
                    </Button>
                    <Button
                      size="small"
                      type="link"
                      onClick={() => this._copyEventSelector(s)}
                    >
                      复制
                    </Button>
                    <Button
                      danger
                      size="small"
                      type="link"
                      onClick={() => {
                        this.setState(({ eventSelectors }) => {
                          eventSelectors.splice(index, 1);
                          return { eventSelectors };
                        });
                      }}
                    >
                      删除
                    </Button>
                  </Col>
                )}
              </Row>
              <Row style={{ marginTop: 3 }}>
                <Col flex="40px"></Col>
                <Col flex="1000px">
                  {s.propertiesSelector == null ? null : (
                    <ConditionsEditor
                      className="event-condition-card"
                      editable={this.props.template == null}
                      conditions={s.propertiesSelector}
                      eventProperties={s.eventProperties}
                      syncConditions={(conds) =>
                        this.syncPropertiesSelector(s, conds)
                      }
                    />
                  )}
                </Col>
              </Row>
            </div>
          ))}
          <Divider
            style={{
              margin: "20px 0 20px 0",
              borderTop: "1px dashed #ccc",
            }}
          />
          {this.props.template != null ? null : (
            <>
              <Row style={{ margin: "10px 0 5px 0" }}>
                <Col flex="40px"></Col>
                <Col>
                  <Button
                    type="primary"
                    size="small"
                    onClick={() => {
                      window.CyaLogger?.sendClick(
                        "事件分析",
                        "query_button_click",
                        {
                          event_date: moment().format("YYYY-MM-DD"),
                          user_name: this.props.user.account,
                        }
                      );
                      this._doQuery();
                    }}
                    style={{ width: 100 }}
                    icon={<SearchOutlined />}
                  >
                    查&nbsp;&nbsp;询
                  </Button>
                </Col>
              </Row>
            </>
          )}
        </div>
        {/* <Divider
            className='event-chart-divider'
            style={{
                margin: '20px 0 20px 0',
            }}
        /> */}
        <div style={{ height: 40 }}></div>
        <Row>
          <Col span={24}>
            <Spin
              spinning={this.state.historyLoading || this.state.todayLoading}
            >
              <Tabs
                style={{ textAlign: "left", padding: "0 6px 0 6px" }}
                activeKey={this.state.chartType}
                onChange={(t) => this.chartTypeChange(t)}
                className="event-chart-tabs"
              >
                <Tabs.TabPane tab="历史数据" key="history">
                  <div style={{ height: 15 }}></div>
                  {this.props.template != null ? (
                    <DatePicker.RangePicker
                      style={{ margin: "10px 10px 0 0" }}
                      disabledDate={historyDisabledDate}
                      value={this.state.rangeDate}
                      onChange={(d) => this.historyRangeDateChange(d)}
                    />
                  ) : null}
                  {emptyData ? (
                    <>
                      <Row justify="center">
                        <Col>
                          <img src="/no_event_data.png"></img>
                        </Col>
                      </Row>
                      <Row justify="center">
                        <Col>
                          <span style={{ color: "#919191", fontSize: 16 }}>
                            请先选择要查询的时间和相关条件后，点击「查询」加载趋势图
                          </span>
                        </Col>
                      </Row>
                    </>
                  ) : null}
                  {this.state.chartType !== "history" ||
                  this.state.historyLoading ||
                  emptyData ? null : (
                    <ReactEcharts
                      option={this.state.chartOption}
                      style={{ height: 450 }}
                    />
                  )}
                </Tabs.TabPane>
                <Tabs.TabPane tab="今日实时" key="today">
                  <div style={{ height: 15 }}></div>
                  {emptyData ? (
                    <>
                      <Row justify="center">
                        <Col>
                          <img src="/no_event_data.png"></img>
                        </Col>
                      </Row>
                      <Row justify="center">
                        <Col>
                          <span style={{ color: "#919191", fontSize: 16 }}>
                            请先选择要查询的时间和相关条件后，点击「查询」加载趋势图
                          </span>
                        </Col>
                      </Row>
                    </>
                  ) : null}
                  {this.state.chartType !== "today" ||
                  this.state.todayLoading ||
                  emptyData ? null : (
                    <ReactEcharts
                      option={this.state.chartOptionToday}
                      style={{ height: 450 }}
                    />
                  )}
                </Tabs.TabPane>
              </Tabs>
            </Spin>
          </Col>
        </Row>
        {this.state.showingSaveModal && (
          <SaveTemplateModal
            visible={this.state.showingSaveModal}
            selectors={this.state.eventSelectors}
            histValues={this.state.d7histValues}
            onOk={() => this._saveTemplateCompleted()}
            onCancel={() => this.setState({ showingSaveModal: false })}
          />
        )}
      </>
    );
  }
}

class SaveTemplateModal extends React.Component {
  constructor() {
    super();
    this.state = {
      name: "",
    };
  }

  async saveTemplate() {
    if (isEmpty(this.state.name)) {
      message.error("请填写模板名称");
      return;
    }

    const request = {
      name: this.state.name,
      selectors: JSON.stringify(this.props.selectors),
      histValues: this.props.histValues,
    };

    const id = await UIFetchService.post(
      "/api/v1/sampling/event/template",
      request
    );
    if (id == null) {
      message.error("模板保存失败");
      return;
    }

    message.success("保存模板成功");
    this.props.onOk();
  }

  render() {
    return (
      <Modal
        title="保存为模板"
        visible={this.props.visible}
        onOk={this.saveTemplate.bind(this)}
        onCancel={() => this.props.onCancel()}
        maskClosable={false}
        width={800}
        okText="保存"
      >
        <Input
          value={this.state.name}
          onChange={(e) => this.setState({ name: e.target.value })}
          placeholder="模板名称"
        />
      </Modal>
    );
  }
}

export default RealtimeAnalysis;
